const ledgerAccountsTabs = {
  LEDGER_ACCOUNTS: 'LEDGER_ACCOUNTS',
  ADDONS: 'ADDONS',
};

export default ledgerAccountsTabs;
